import React from 'react';
import { FormFiltros } from './components/FormFiltros';
import { TableTitulos } from './components/TableTitulos';
import { FormQuitacao } from './components/FormQuitacao';
import { BtnContainer, Container } from './styles';
import DefaultLoader from '~/components/DefaultLoader';
import { useQuitacao } from './QuitacaoContext';
import FormDefault from '~/components/FormDefault';
import { Button } from 'react-bootstrap';

const QuitacaoEmLote: React.FC = () => {
  const { loader, handleQuitarParcelas } = useQuitacao();

  if (loader) {
    return (
      <Container>
        <DefaultLoader />
      </Container>
    );
  }
  return (
    <Container>
      <FormDefault
        codTela={55}
        onSave={() => Promise.resolve()}
        onCancel={() => []}
        onClearFields={() => []}
        onNew={() => []}
        onDelete={() => []}
        onReturnSearch={() => []}
        isCancel={false}
        isBackSearch={false}
        isClear={false}
        isSave
        customButtons={
          <BtnContainer>
            <Button
              className="btn-quitacao"
              onClick={handleQuitarParcelas}
              disabled={false}
            >
              Quitar
            </Button>
          </BtnContainer>
        }
      >
        <FormFiltros />
        <TableTitulos />
        <FormQuitacao />
        <br />
      </FormDefault>
    </Container>
  );
};

export default QuitacaoEmLote;
